export default "__VITE_ASSET__B9SrXvU4__"